// Remembers the last branding / temple logo so pages show the right logo immediately
// instead of flashing default icons while it loads. Storage may be unavailable (private mode).
export function readCache(key) {
  try { return JSON.parse(localStorage.getItem(key) || "null"); } catch { return null; }
}

export function writeCache(key, value) {
  try { localStorage.setItem(key, JSON.stringify(value)); } catch { /* storage full or blocked */ }
}
